import { RFIconProps } from "../types";

export default function CircleCloseIcon(props: RFIconProps) {
	return (
		<svg
			viewBox="0 0 1024 1024"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			width="150"
			height="150"
			{...props}
			className={props.className || "w-6 h-6"}
		>
			<path
				d="M512 212c40.53 0 79.81 7.92 116.75 23.55 35.72 15.11 67.81 36.75 95.38 64.32 27.57 27.57 49.21 59.66 64.32 95.38C804.08 432.19 812 471.47 812 512s-7.92 79.81-23.55 116.75c-15.11 35.72-36.75 67.81-64.32 95.38-27.57 27.57-59.66 49.21-95.38 64.32C591.81 804.08 552.53 812 512 812s-79.81-7.92-116.75-23.55c-35.72-15.11-67.81-36.75-95.38-64.32-27.57-27.57-49.21-59.66-64.32-95.38C219.92 591.81 212 552.53 212 512s7.92-79.81 23.55-116.75c15.11-35.72 36.75-67.81 64.32-95.38 27.57-27.57 59.66-49.21 95.38-64.32C432.19 219.92 471.47 212 512 212m0-64c-201.03 0-364 162.97-364 364s162.97 364 364 364 364-162.97 364-364-162.97-364-364-364z"
				fill="currentColor"
			></path>
			<path
				d="M664.74 664.74c-12.5 12.5-32.76 12.5-45.25 0L512 557.25 404.52 664.74c-12.5 12.5-32.76 12.5-45.25 0-12.5-12.5-12.5-32.76 0-45.25L466.75 512 359.26 404.52c-12.5-12.5-12.5-32.76 0-45.25 12.5-12.5 32.76-12.5 45.25 0L512 466.75l107.48-107.48c12.5-12.5 32.76-12.5 45.25 0 12.5 12.5 12.5 32.76 0 45.25L557.25 512l107.48 107.48c12.5 12.5 12.5 32.76 0.01 45.26z"
				fill="currentColor"
			></path>
		</svg>
	);
}
